import React, { Component, useContext, useState  } from "react";
import { Navigate, Link, useLocation, useNavigate } from 'react-router-dom';
import ModalTemplate from "./ModalTemplate";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBSelect
} from 'mdb-react-ui-kit';


class DeleteModal extends Component {

	constructor(props) {
    super(props);
    this.state = {
      btnForm: [  {classname: "cancel" , onclick: this.props.hideModal , text: "Cancel"},
                  {classname: "save" , onclick: this.internalHandleSave , text: "Delete"}
               ]
    };
  }

  componentDidMount() {
  }

  internalHandleSave = () => {
    this.props.onDeleteFooter(this.props.footerId);
    this.props.hideModal();
  }


	render() {

    return (
      <ModalTemplate
  				{...this.props}
  				internalHandleSave={this.internalHandleSave}
          btnForm={this.state.btnForm}
          modalId={""}
  			>
        {this.props.modalText}

      </ModalTemplate>
  );
  }
}
export default DeleteModal;
